import { UnitTransferEventTypeEnumType } from '__generated__/graphql';

export default function unitTransferEventTypeToReadable(
  type: UnitTransferEventTypeEnumType
): string {
  switch (type) {
    case UnitTransferEventTypeEnumType.Created:
      return 'Request created';
    case UnitTransferEventTypeEnumType.Submitted:
      return 'Request submitted';
    case UnitTransferEventTypeEnumType.TransfereeAcknowledged:
      return 'Transferee acknowledged the request';
    case UnitTransferEventTypeEnumType.TransfereeDeclined:
      return 'Transferee declined the request';
    case UnitTransferEventTypeEnumType.ReviewStarted:
      return 'Review started';
    case UnitTransferEventTypeEnumType.EscrowExceptionRequested:
      return 'Escrow-direct exception requested';
    case UnitTransferEventTypeEnumType.EscrowExceptionOpsApproved:
      return 'Escrow exception approved by ops';
    case UnitTransferEventTypeEnumType.EscrowExceptionApproved:
      return 'Escrow exception approved';
    case UnitTransferEventTypeEnumType.EscrowExceptionDeclined:
      return 'Escrow exception declined';
    case UnitTransferEventTypeEnumType.JointDematOverridden:
      return 'Joint demat warning overridden';
    case UnitTransferEventTypeEnumType.ConditionsIssued:
      return 'Conditions issued';
    case UnitTransferEventTypeEnumType.DocumentUploaded:
      return 'Document uploaded';
    case UnitTransferEventTypeEnumType.DocumentsSubmittedForReview:
      return 'Documents submitted for review';
    case UnitTransferEventTypeEnumType.DocumentsMarkedIncomplete:
      return 'Documents marked incomplete';
    case UnitTransferEventTypeEnumType.DocumentsVerified:
      return 'Documents verified';
    case UnitTransferEventTypeEnumType.ValuationReportRequested:
      return 'Valuation report requested';
    case UnitTransferEventTypeEnumType.SigningInitiated:
      return 'Signing initiated';
    case UnitTransferEventTypeEnumType.SignatureSent:
      return 'Signature request sent';
    case UnitTransferEventTypeEnumType.SignatureCompleted:
      return 'A signature was completed';
    case UnitTransferEventTypeEnumType.SignatureDeclined:
      return 'A signature was declined';
    case UnitTransferEventTypeEnumType.EffectiveDateSet:
      return 'Effective date set';
    case UnitTransferEventTypeEnumType.ExecutionCompleted:
      return 'Execution completed';
    case UnitTransferEventTypeEnumType.DisUnlocked:
      return 'DIS unlocked';
    case UnitTransferEventTypeEnumType.Rejected:
      return 'Request rejected';
    case UnitTransferEventTypeEnumType.Withdrawn:
      return 'Request withdrawn';
    case UnitTransferEventTypeEnumType.NoteAdded:
      return 'Note added';
    default:
      return type;
  }
}
